@if (race.addons.raceSummary) {
    <div class="gh-race-off-container">
        @if (isRaceOff) {
            <vn-icon class="gh-greyhounds-race-off" name="sports-greyhounds-race-off" size="16"></vn-icon>
        }
        <span [ngClass]="isRaceOff ? 'gh-race-off' : 'raceSummary'">{{ race.addons.raceSummary }}</span>
    </div>
} @else {
    <div class="timer-container">
        @if (display && timeInSeconds > 0) {
            <span class="greyhound-timer-startsIn">{{ sitecore.horseRacing.nextThreeRaces.StartsIn }}</span>
        }
        <ms-countdown-timer
            class="greyhound-race-status-text"
            [timeInSeconds]="timeInSeconds"
            [textAfterTimerFinished]="sitecore.horseRacing.raceSummary!.PostTime"
            [isSports]="true"
            (display)="onDisplay($event)">
        </ms-countdown-timer>
    </div>
}
